import Table from "../../../components/Table/Table";
import Button from "../../../components/Button";
import Modal from "../../../components/Modal";
import { useState, useEffect } from "react";
import VerticalLine from "../../../assets/images/verticallines.svg";
import { Grid } from "@mui/material";
import { TableSearch } from "../../../components/Table/TableActions";
import { Icon } from "@iconify/react";
import InputGroup from "../../../components/FormComponent/InputGroup";
import { httprequest } from "../../../data/api";
import { toast } from "react-toastify";
import useValidator from "../../../hooks/useValidator";
import useStyles from "../../inventory/styles";
import PageLoader from "../../../components/PageLoader";
import useWindowSize from "../../../hooks/useWindow";
import { useParams } from "react-router-dom";

const INVENTORY_CATEGORY_ENDPOINT = "/api/v1/hostel-management/hostel-inventory";

const InventoryCategory = () => {
  const classes = useStyles();
  const { id } = useParams();
  const [editInventoryCategoryModal, setEditCategoryModal] = useState(false);
  const [deleteInvCategoryModal, setDeleteInvCategoryModal] = useState(false);
  const [currentDelete, setCurrentDelete] = useState("");
  const [currentRow, setCurrentRow] = useState({});
  const [isCategoryFetching, setIsCategoryFetching] = useState(false);
  const [categoryData, setCategoryData] = useState([]);
  const [searchResult, setSearchResult] = useState([]);
  const [manageCategoryModal, setManageCategoryModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [allAuditLog, setAuditLogs] = useState([]);
  const [activeRow, setActiveRow] = useState(null);
  const [isEditLoading, setIsEditLoading] = useState(false);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [getIsLogsLoading, setGetIsLogsLoading] = useState(false);
  const width = useWindowSize();
  const [auditModal, setAuditModal] = useState(false);
  const AuditMobile = width < 900;
  const mobile = width < 600;

  const [inventoryCategoryValidator, showInventoryCategoryValidator] = useValidator();
  const [editInventoryValidator, showEditInventoryValidator] = useValidator();
  const [manageArr, setManageArr] = useState([""]);
  const [manageForm, setManageForm] = useState({
    categories: [{ category: "" }]
  });

  const [editInvCategory, setEditInvCategory] = useState({
    category: ""
  });

  const handleEditCategoryChange = (e) => {
    const { name, value } = e.target;
    setEditInvCategory({ ...editInvCategory, [name]: value });
  };

  const handleDeleteModal = (row) => {
    setDeleteInvCategoryModal(true);
    setCurrentDelete(row);
  };

  const handleCloseDeleteModal = () => {
    setDeleteInvCategoryModal(false);
    setCurrentDelete({});
  };

  const handleEditInvModal = (row) => {
    setCurrentRow(row);
    setEditInvCategory({ ...editInvCategory, category: row?.category });
    setEditCategoryModal(true);
  };

  const handleManageChange = (e, index) => {
    const { value } = e.target;
    const allItems = [...manageArr];
    allItems[index] = value;
    setManageArr(allItems);
    const formattedCategories = allItems?.map(item => ({ category: item }));
    setManageForm({ categories: formattedCategories });
  };

  const handleDeleteManageItem = (index) => {
    const newItem = manageArr.filter((_item, ind) => ind !== index);
    setManageArr(newItem);

    const formatted = newItem.map(item => ({ category: item }));
    setManageForm({ categories: formatted });
  };

  const addAdditional = () => {
    const newItem = "";
    const updatedArr = [...manageArr, newItem];
    setManageArr(updatedArr);

    const formatted = updatedArr.map(item => ({ category: item }));
    setManageForm({ categories: formatted });
  };

  const handleManageCategoryModal = () => {
    setManageCategoryModal(!manageCategoryModal);

    const initial = [""];
    setManageArr(initial);
    setManageForm({ categories: initial.map(item => ({ category: item })) });
  };

  const handleCloseEditOptionsModal = () => {
    setCurrentRow({});
    setEditInvCategory({ ...editInvCategory, category: "" });
    setEditCategoryModal(false);
  };

  // Get sCHOOL Audit Data
  const getCategoryAuditInfo = (category_id) => {
    // setCurrentRow(row);
    setGetIsLogsLoading(true);
    httprequest
      .get(`${INVENTORY_CATEGORY_ENDPOINT}/${id}/category/${category_id}`)
      .then((res) => {
        setAuditLogs(res?.data?.data);
        setGetIsLogsLoading(false);
      }).catch((err) => {
        setGetIsLogsLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  const getAllInvCategory = () => {
    setIsCategoryFetching(true);
    httprequest.get(`${INVENTORY_CATEGORY_ENDPOINT}/${id}/categories`).then((res) => {
      setIsCategoryFetching(false);
      const firstItem = res?.data?.data?.[0];

      setCategoryData(res?.data?.data);
      setSearchResult(res?.data?.data);
      if (firstItem) {
        setCurrentRow(firstItem);
        setActiveRow(0);
        getCategoryAuditInfo(firstItem?.id);
      }
    }).catch((err) => {
      setIsCategoryFetching(false);
      toast.error(err?.response?.data?.message);
    });
  };

  const handleRowClick = (index, row) => {
    setCurrentRow(row);
    setActiveRow(index);
    getCategoryAuditInfo(row?.id);
  };

  const handleAuditModal = (index, row) => {
    setAuditModal(!auditModal);
    setCurrentRow(row);
    setActiveRow(index);
    getCategoryAuditInfo(row?.id);
  };

  const handleCloseAuditModal = () => {
    setAuditModal(false);
    setCurrentRow({});
  };

  const handleCreateInvCategory = () => {
    if (inventoryCategoryValidator.allValid()) {
      setIsLoading(true);
      httprequest.post(`${INVENTORY_CATEGORY_ENDPOINT}/${id}/category`, manageForm).then((res) => {
        setIsLoading(false);
        toast.success(res?.data?.message);
        getAllInvCategory();
        // setInventoryCategory({ ...inventoryCategory, category: "" });
        handleManageCategoryModal();
      }).catch((err) => {
        setIsLoading(false);
        toast.error(err?.response?.data?.message);
      });
    } else {
      showInventoryCategoryValidator(true);
    }
  };

  const handleDeleteInvCategory = () => {
    setIsDeleteLoading(true);
    httprequest.delete(`${INVENTORY_CATEGORY_ENDPOINT}/${id}/category/${currentDelete?.id}`).then(() => {
      setIsDeleteLoading(false);
      toast.success("Invemtory Category Deleted Successfully");
      getAllInvCategory();
      handleCloseDeleteModal();
    }).catch((err) => {
      setIsDeleteLoading(false);
      toast.error(err?.response?.data?.message);
    });
  };

  const handleEditInvCategory = () => {
    if (editInventoryValidator.allValid()) {
      setIsEditLoading(true);
      httprequest.patch(`${INVENTORY_CATEGORY_ENDPOINT}/${id}/category/${currentRow?.id}`, editInvCategory).then(() => {
        setIsEditLoading(false);
        toast.success("Invoice Category Edited");
        getAllInvCategory();
        setEditInvCategory({ ...editInvCategory, category: "" });
        handleCloseEditOptionsModal();
      }).catch((err) => {
        setIsEditLoading(false);
        toast.error(err?.response?.data?.message);
        handleCloseEditOptionsModal();
      });
    } else {
      showEditInventoryValidator(true);
    }
  };

  // --| Filter Inventory Category table using type, number of days, who can access
  const handleSearchInvCategory = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = categoryData?.filter((data) => valArray?.every(
      (word) => data?.category
        ?.toLowerCase()
        .includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  useEffect(() => {
    getAllInvCategory();
  }, []);

  const columns = [
    {
      name: "Category Name",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Category Name</p>}
          {row?.category || "--/--"}
        </>
      )
    },
    {
      name: "Date Created",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Date Created</p>}
          {row?.created_at?.substring(0, 10)}
        </>
      )
    },
    {
      name: "Date Updated",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Date Updated</p>}
          {row?.updated_at?.substring(0, 10)}
        </>
      )
    },
    {
      name: " ",
      cell: (row, index) => (
        <div key={row?.id} className="table-action-container">
          <button
            onClick={() => AuditMobile ? handleAuditModal(index, row) : handleRowClick(index, row)}
            className={`table-action-icon ${activeRow === index ? "info-icon" : ""}`}
          >
            <Icon icon="iconamoon:question-mark-circle" width="20" height="20" />
          </button>
          <button className="table-action-icon" onClick={() => {
            handleEditInvModal(row);
          }}
          >
            <Icon icon="heroicons:pencil-square-solid" />
          </button>
          <button
            onClick={() => handleDeleteModal(row)}
            className="table-action-icon delete-icon"
          >
            <Icon icon="mingcute:delete-2-line" />
          </button>
        </div>
      )
    }
  ];

  // const { category } = inventoryCategory;

  return (
    <>
      <div className="breadcrumb-container">
        <Button
          variant="primary"
          buttonSize="fluid"
          color="btndefault"
          onClick={handleManageCategoryModal}
          buttonName="Add Inventory Category"
        />
      </div>
      <Grid container spacing={4}
        sx={{
          "@media (max-width: 1000px)": {
            flexWrap: "wrap-reverse"
          }
        }}
      >
        <Grid item lg={8} md={8} sm={12} xs={12}>
          <div className="left-container border_only">
            <>
              {isCategoryFetching ? (
                <PageLoader />
              ) : (
                <Table
                  data={searchResult}
                  columns={columns}
                  subHeader={true}
                  isLoading={isCategoryFetching}
                  subHeaderComponent={
                    <TableSearch placeholder="Search here..." searchTableFunc={handleSearchInvCategory} />}
                  pagination
                />
              )}
            </>
          </div>
        </Grid>
        {!AuditMobile && (
          <Grid item lg={4} md={4} sm={12} xs={12}>
            <div className={`${classes.rightitems} right-container border_only`}>
              <div className={classes.logtitle}><h4>{`Audit Log of ${currentRow?.category || "--/--"} Category`}</h4></div>
              {getIsLogsLoading ? (
                <PageLoader />
              ) : (
                allAuditLog?.audit_trail?.map((update, i) => {
                  const isLastItem = i === allAuditLog?.length - 1;

                  return (
                    <div key={i}>
                      <div className="flex gap-10 align-items-center margin-bottom-10">
                        <Icon
                          icon="lets-icons:check-fill"
                          style={{ color: "#3FAC64", height: "32px", width: "32px" }}
                        />
                        <div className={classes.logdetails}>
                          <h5>Updated at</h5>
                          <h5>{update?.updated_at?.substring(0, 10)} | {update?.updated_at?.substring(11, 16)}</h5>
                          <p>{update?.updated_by?.last_name || "--/--"} {update?.updated_by?.last_name || "--/--"}</p>
                        </div>
                      </div>
                      {!isLastItem && (
                        <div className={classes.verticalline}>
                          <img src={VerticalLine} alt="" />
                        </div>
                      )}
                    </div>
                  );
                })
              )}
              <div className="flex gap-10 align-items-center margin-bottom-10">
                <Icon
                  icon="mdi:cloud-clock-outline"
                  width="25"
                  height="25"
                  style={{
                    color: "#0e9504",
                    border: "1px solid #0e9504",
                    borderRadius: "20px",
                    padding: "5px",
                    marginLeft: "5px"
                  }}
                />
                <div>
                  <h5>Created at</h5>
                  <p>{allAuditLog?.created_at?.substring(0, 10) || "-/-"} | {allAuditLog?.created_at?.substring(11, 16) || "-/-"}</p>
                  <p>{allAuditLog?.created_by_user?.last_name || "--/--"} {allAuditLog?.created_by_user?.first_name || "--/--"}</p>
                </div>
              </div>
            </div>
          </Grid>
        )}
      </Grid>
      {/* Manage Category Modal */}
      <Modal
        title="Manage Inventory Category"
        subtitle={
          <div>Assign items to categories for better tracking and reporting.
          </div>}
        modalContent={
          <>
            <Grid container spacing={2} className="input-padding">
              <Grid item lg={12} md={12} sm={12} xs={12}>
                {manageArr?.map((item, index) => (
                  <div key={index} className={classes.manageitems}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <InputGroup
                        label="Category Name"
                        margin="normal"
                        required
                        placeHolder="Enter category name"
                        inputType="text"
                        inputName="category"
                        onChange={(e) => handleManageChange(e, index)}
                        value={item}
                      />
                      {inventoryCategoryValidator.message(`Category ${index + 1}`, manageForm?.categories[index]?.category, "required")}
                    </Grid>
                    <div className={classes.anitem}>
                      {manageForm?.categories?.length > 1 ? (
                        <p
                          className={classes.deleteitem}
                          onClick={() => {
                            handleDeleteManageItem(index);
                          }}
                        >
                          {/* <Icon icon="zondicons:minus-solid" /> */}
                                                              Remove
                        </p>
                      ) : null}
                    </div>
                  </div>
                ))}
              </Grid>
            </Grid>
            <div
              className={`${classes.mail} flex align-items-center `}
              onClick={addAdditional}
            >
              <p>Add Category</p>
              <Icon icon="octicon:feed-plus-16" width="16" height="16" />
            </div>
          </>
        }
        modalFooter={
          <>
            <Button variant="primary" buttonName="Save Labels" buttonSize="full" color="btndefault" isLoading={isLoading} onClick={handleCreateInvCategory} />
          </>
        }
        isopen={manageCategoryModal}
        closeModal={handleManageCategoryModal}
      />
      {/* DELETE CURRENT */}
      <Modal
        title="Delete Current Inventory Category"
        subtitle={`Are you sure you want to delete this  ${currentDelete?.category} inventory category?. If you delete it, it becomes unavaiable for the whole school.`}
        modalContent={
          <>
            <div>
            </div>
          </>
        }
        modalFooter={
          <>
            <Button
              type="submit"
              variant="danger"
              buttonName="Delete Inventory Category"
              buttonSize="full"
              color="btndefault"
              onClick={handleDeleteInvCategory}
              isLoading={isDeleteLoading}
            />
          </>
        }
        isopen={deleteInvCategoryModal}
        closeModal={handleCloseDeleteModal}
      />

      {/* Modal to edit inventory category */}
      <Modal
        title="Edit Inventory Category"
        subtitle="Edit your current inventory category"
        modalContent={
          <>
            <Grid container spacing={2} className="input-padding">
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <InputGroup inputName="category" type="text" label="Category Name" defaultValue={editInvCategory?.category} onChange={handleEditCategoryChange} />
                {editInventoryValidator.message("Category Name", editInvCategory?.category, "required")}
              </Grid>
            </Grid>
          </>
        }
        modalFooter={
          <>
            <Button
              type="submit"
              onClick={handleEditInvCategory}
              variant="primary"
              buttonName="Edit Inventory Category"
              buttonSize="full"
              color="btndefault"
              isLoading={isEditLoading}
            />
          </>
        }
        isopen={editInventoryCategoryModal}
        closeModal={handleCloseEditOptionsModal}
      />
      {/* Modal For Audit inventory category */}
      <Modal
        title={`Audit Log of ${currentRow?.category || "--/--"} Category`}
        subtitle="Audit log of your current inventory category"
        modalContent={
          <>
            <Grid container spacing={2} className="input-padding">
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <div className={`${classes.rightitems} right-container`}>
                  {/* <div className={classes.logtitle}><h4>{`Audit Log of ${currentRow?.category || "--/--"} Category`}</h4></div> */}
                  {getIsLogsLoading ? (
                    <PageLoader />
                  ) : (
                    allAuditLog?.audit_trail?.map((update, i) => {
                      const isLastItem = i === allAuditLog?.length - 1;

                      return (
                        <div key={i}>
                          <div className="flex gap-10 align-items-center margin-bottom-10">
                            <Icon
                              icon="lets-icons:check-fill"
                              style={{ color: "#3FAC64", height: "32px", width: "32px" }}
                            />
                            <div className={classes.logdetails}>
                              <h5>Updated at</h5>
                              <h5>{update?.updated_at?.substring(0, 10)} | {update?.updated_at?.substring(11, 16)}</h5>
                              <p>{update?.updated_by?.last_name || "--/--"} {update?.updated_by?.last_name || "--/--"}</p>
                            </div>
                          </div>
                          {!isLastItem && (
                            <div className={classes.verticalline}>
                              <img src={VerticalLine} alt="" />
                            </div>
                          )}
                        </div>
                      );
                    })
                  )}
                  <div className="flex gap-10 align-items-center margin-bottom-10">
                    <Icon
                      icon="mdi:cloud-clock-outline"
                      width="25"
                      height="25"
                      style={{
                        color: "#0e9504",
                        border: "1px solid #0e9504",
                        borderRadius: "20px",
                        padding: "5px",
                        marginLeft: "5px"
                      }}
                    />
                    <div>
                      <h5>Created at</h5>
                      <p>{allAuditLog?.created_at?.substring(0, 10)} | {allAuditLog?.created_at?.substring(11, 16)}</p>
                      <p>{allAuditLog?.created_by_user?.last_name || "--/--"} {allAuditLog?.created_by_user?.first_name || "--/--"}</p>
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </>
        }
        modalFooter={
          <>
          </>
        }
        isopen={auditModal}
        closeModal={handleCloseAuditModal}
      />
      {/* <ToastContainer /> */}
    </>
  );
};

export default InventoryCategory;
